// const ConfigurationPage = () => import("../components/ConfigurationPage.vue");
import ConfigurationPage from '../components/ConfigurationPage.vue';

export default [
    {
      path: "/Configuration/Users",
      name: "Users",
      component: ConfigurationPage,
      meta: { requiresAuth: true, checkPermissions: true, module: "configuration", feature: "user_management" }
    },
    {
      path: "/Configuration/Permissions/logs",
      name: "Permissions Log",
      component: ConfigurationPage,
      meta: { requiresAuth: true, checkPermissions: true, module: "configuration", feature: "user_management" }
    },
    {
      path: "/Configuration/Permissions",
      name: "Permissions",
      component: ConfigurationPage,
      meta: { requiresAuth: true, checkPermissions: true, module: "configuration", feature: "user_management" }
    },
    {
      path: "/Configuration/user_log",
      name: "User Log",
      component: ConfigurationPage,
      meta: { requiresAuth: true, checkPermissions: true, module: "configuration", feature: "user_management" }
    },
    {
        path: "/Configuration/Asset/:subPage",
        name: "Asset",
        component: ConfigurationPage,
        meta: { requiresAuth: true, checkPermissions: true, module: "configuration", feature: "asset" }
    },
    {
        path: "/Configuration/Chemical/:subpage",
        name: "Chemical",
        component: ConfigurationPage,
        meta: { requiresAuth: true, checkPermissions: true, module: "configuration", feature: "chemical" }
    },
    {
        path: "/Configuration/Inventory/:subPage",
        name: "Inventory Config",
        component: ConfigurationPage,
        meta: { requiresAuth: true, checkPermissions: true, module: "configuration", feature: "inventory" }
    },
    {
        path: "/Configuration/Thresholds/:subPage",
        name: "Thresholds",
        component: ConfigurationPage,
        meta: { requiresAuth: true, checkPermissions: true, module: "configuration", feature: "thresholds" }
    },
    {
        path: "/Configuration/Locations",
        name: "Locations",
        component: ConfigurationPage,
        meta: { requiresAuth: true, checkPermissions: true, module: "configuration", feature: "locations" }
    },
    {
        path: "/Configuration/Manufacturers",
        name: "Manufacturers",
        component: ConfigurationPage,
        meta: { requiresAuth: true, checkPermissions: true, module: "configuration", feature: "manufacturers" }
    },
    {
        path: "/Configuration/Vendors",
        name: "Vendors",
        component: ConfigurationPage,
        meta: { requiresAuth: true, checkPermissions: true, module: "configuration", feature: "vendors" }
    },
    {
        path: "/Configuration",
        name: "Configuration",
        component: ConfigurationPage,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "configuration",
          title: "CruzControl | Configuration"
        }
    },
    {
        path: "/Configuration/Tenant/UnitOfMeasure",
        name: "UnitOfMeasure",
        component: ConfigurationPage,
        meta: { requiresAuth: true, checkPermissions: true, module: "configuration", feature: "unit_of_measure", subPage: "UnitOfMeasure" }
    },
    {
        path: "/Configuration/Tenant/Regions",
        name: "Regions",
        component: ConfigurationPage,
        meta: { requiresAuth: true, checkPermissions: true, module: "configuration", feature: "regions", subPage: "Regions" }
    },
]